




































import Vue from 'vue'
import {DateTime} from 'luxon'
import moment from 'moment'
import {momentLang as lang} from '@/lang/index';

import UiCalendarSheet from './CalendarSheet.vue'
import UiInlineIcon from '../Ui/Icon/InlineIcon.vue'

export default Vue.extend({
  name: 'UiCalendar',
  components: {UiCalendarSheet, UiInlineIcon},
  props: {
    monthSwitchers: {type: Boolean, default: true},
    value: {type: String as () => string},
    available: {
      type: Object as () => any,
      default: () => {
        return {}
      }
    },
    monthDiff: Number
  },
  data () {
    return {
      moment,
      currentMonth: '',
      weekdays: [
        this.$t('labels.weekdays_short.monday'),
        this.$t('labels.weekdays_short.tuesday'),
        this.$t('labels.weekdays_short.wednesday'),
        this.$t('labels.weekdays_short.thursday'),
        this.$t('labels.weekdays_short.friday'),
        this.$t('labels.weekdays_short.saturday'),
        this.$t('labels.weekdays_short.sunday')
      ],
      width: 0,
      locale: lang
    }
  },
  mounted () {
    this.width = this.$el.clientWidth
  },
  watch: {
    months () {
      this.$emit('fillMonths', this.months)
    }
  },
  computed: {
    months (): DateTime[] {
      const months = [this.getDate()]

      if (this.width > 400) {
        months.push(this.getDate('next'))
      }
      return months
    },
    currentValue: {
      get (): string {
        return this.value
      },
      set () {
      }
    }
  },
  methods: {
    monthName (date: Date): string {
      // @ts-ignore
      return moment(date.ts).locale(this.locale).format('MMMM')
    },
    onResize () {
      this.width = this.$el.clientWidth
    },
    onInput (value: any) {
      this.$emit('input', value)
    },
    getDate (month?: string) {
      let date = DateTime.local().plus({month: this.monthDiff})
      if (month === 'next') {
        date = date.plus({months: 1})
      }
      return date.startOf('month')
    }
  }
})
